export const PromoteDemoteActions = {
    Demote: 'Demote',
    Promote: 'Promote',
} as const

export const NOT_FOUND = 'No content found to'
export const NO_ACTIVE_ID = 'No active item to'

export const INCONSISTENT_PARAGRAPH_LEVEL_ERROR = {
    message:
        'The action could not be completed. Be sure to maintain a consistent outline structure.',
    description:
        'This operation would exceed the maximum depth limit of 5 levels.',
}
